import React from 'react';
import { createPortal } from 'react-dom';

export type ConversationsPhotoPreviewModalProps = {
  open: boolean;
  src: string | null;
  alt: string;
  onClose: (event?: React.SyntheticEvent) => void;
};

export default function ConversationsPhotoPreviewModal({
  open,
  src,
  alt,
  onClose,
}: ConversationsPhotoPreviewModalProps) {
  if (!src || !open || typeof document === 'undefined') return null;

  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center">
      <div className="absolute inset-0 bg-black/70" onClick={onClose} />
      <div className="relative z-10 flex flex-col items-end gap-3 px-4">
        <button
          type="button"
          onClick={onClose}
          className="rounded-full bg-white/90 px-3 py-1 text-xs font-semibold text-gray-700 shadow-md hover:bg-white"
        >
          Fechar
        </button>
        <img
          src={src}
          alt={alt}
          className="max-h-[80vh] max-w-[85vw] rounded-2xl shadow-2xl object-contain"
        />
      </div>
    </div>,
    document.body
  );
}
